import React, {
  useState,
  useEffect,
useReducer,
} from "react";

import getDay from "../function/getDay.js";
import getUrl from "../function/getUrl.js";
import checkLogin from "../function/checkLogin.js";
import birthdayToAge from "../function/birthdayToAge.js";


//當月體驗生
const DashBoardMonthlyTrailStudents = (props) => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [trialList, setTrialList] = useState([]);
  const [coachList,setCoachList]=useState([])
  const [assistantList,setAssistantList]=useState([])
  const [follow,setFollow]=useState([])
  const [monthCountArray,setMonthCountArray]=useState([])
  const [monthList,setMonthList]=useState([])

  let today = getDay(0, "-");
  if (!checkLogin()) {
    window.location.href = "/logout";
  }

  const filterInitial = {
    type: "全部",
    coachName: "全部",
    assistantName: "全部",
    sort:"desc",
    month:"全部"
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "type":
        return { ...state, type: action.value };
      case "coachName":
        return { ...state, coachName: action.value };
      case "assistantName":
        return { ...state, assistantName: action.value };
      case "sort":
        return { ...state, sort: action.value };
      case "month":
        return { ...state, month: action.value };
      case "reset":
        return filterInitial;
      default:  
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, filterInitial);

  useEffect(async () => {
   const reulst= await fetch(`${url}/appGet/GetStudentTrialListForMothlyList?token=${token}`)
      .then((res) => res.json())
      console.log(reulst)
    setFollow(reulst.follow)
     let sortedList = [...reulst.studentList];
     sortedList.sort((a, b) => new Date(b.classDate) - new Date(a.classDate))
    setTrialList(sortedList)
    //整理 result.studentList.coachName 內的教練名單
    let coachArray=[]
    reulst.studentList.forEach(item=>{
      if(!coachArray.includes(item.coachName)){
        coachArray.push(item.coachName)
      }
    })
    setCoachList(coachArray)
    //整理 result.studentList.assistantName 內的助教名單
    let assistantArray=[]
    reulst.studentList.forEach(item=>{
      if (item.assistantName && item.assistantName!="" && item.assistantName!=null && item.assistantName!=undefined){
      if(!assistantArray.includes(item.assistantName)){
        assistantArray.push(item.assistantName)
      }
    }
    })
    setAssistantList(assistantArray)

    //計算每個月 轉正式的人數
   let monthCount = {};
    reulst.studentList.forEach(item => {
      let month = item.classDate.split("-")[1];
      if (!monthCount[month]) {
        monthCount[month] = {
          total: 0,
          flagCount: 0
        };
      }
      if (item.flag === "1") {
        monthCount[month].flagCount++;
      }
      monthCount[month].total++;
    });
    console.log(monthCount);
  // monthCount 轉成 array
    let tempMonthCountArray = [];
    for (let month in monthCount) {
      tempMonthCountArray.push({
        month: month,
        total: monthCount[month].total,
        flagCount: monthCount[month].flagCount
      });
    }
    tempMonthCountArray.sort((a, b) => a.month - b.month);
    console.log(tempMonthCountArray);
    setMonthCountArray(tempMonthCountArray);

     //整理 result 內的月份
    let monthArray=[]
    reulst.studentList.forEach((item)=>{
      let month=item.classDate.split("-")[1]
      if(!monthArray.includes(month)){
        monthArray.push(month)
      }
    })
    //排序
    monthArray.sort( (a, b) => a - b)
    setMonthList(monthArray)
   
  },[])

  useEffect(() => {
    let sortedList = [...trialList];
    if (state.sort === "asc") {
      sortedList.sort((a, b) => new Date(a.classDate) - new Date(b.classDate));
    } else {
      sortedList.sort((a, b) => new Date(b.classDate) - new Date(a.classDate));
    }
    setTrialList(sortedList);
  }, [state.sort]);
 
  return (
    <>
      <div className="card" style={{ width: "18rem;" }}>
        <div className="card-header">三個月體驗完課追蹤-({trialList.length}位）<small>依體驗完課日期</small></div>
            <div className="card-body"> 
       <div className="row">
          <table className="table table-striped">
            <thead className="text-center">
              <tr>
                <th scope="col">月份</th>
                <th scope="col">轉正式人數</th>
                <th scope="col">總人數</th>
                <th scope="col">轉正式率</th>
              </tr>
            </thead>
            <tbody className="text-center">
            {monthCountArray.map((item)=>{
              return(
                <tr key={item.month}>
                  <td>{item.month}月</td>
                  <td>{item.flagCount}</td>
                  <td>{item.total}</td>
                  <td>{((item.flagCount/item.total)*100).toFixed(2)}%</td>
                </tr>
              )
            })}
            </tbody>
          </table>
         
          </div>
     
          <div className="row">
                    <table class="table table-striped">
          <thead>
            <tr className="text-center">
              <th scope="col">序號</th>
              <th scope="col">編號</th>
              <th scope="col">姓名/暱稱</th>
              <th scope="col">家長電話</th>
              <th scope="col">體驗完課日期
                 <select onChange={(e)=>{
                  dispatch({type:"month", value:e.target.value})
                }}>
                  <option>全部</option>
                  {monthList.map((item)=>{
                    return(
                      <option value={item}>{item}月</option>
                    )
              })}
            </select>
            <select onChange={(e)=>{
                  dispatch({type:"sort", value:e.target.value})
                }}>
                  <option value="desc">新到舊</option>
                  <option value="asc">舊到新</option>
            </select>
                
              </th>
              <th scope="col">體驗完課時間</th>
              <th scope="col">是否轉正式<select onChange={(e)=>{
                dispatch({type:"type", value:e.target.value})
              }} >
                <option>全部</option>
                <option value="是">是</option>
                <option value="否">否</option>
              </select></th>
              <th scope="col">連絡&聯繫者</th>
           
                <th scope="col">教練
                  <select onChange={(e)=>{
                  dispatch({type:"coachName", value:e.target.value})
                }}>
                  <option>全部</option>
                  {coachList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
            </select>
                </th>
              <th scope="col">助教

               <select onChange={(e)=>{
                  dispatch({type:"assistantName", value:e.target.value})
                }}>
                  <option>全部</option>
                  {assistantList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
              </select>
              </th>
         
            </tr>
          </thead>
          <tbody className="text-center">
            {trialList.map((item, index) => {
              if (state.type!="全部"){
               switch(state.type){
                case "是":
                  if (item.flag!="1"){
                    return null
                  }
                  break;
                case "否":
                  if (item.flag=="1"){
                    return null
                  }
                  break;
              } 
              }

              if (state.coachName!="全部"){
                if (item.coachName!=state.coachName){
                  return null
                }
              }

              if (state.assistantName!="全部"){
                if (item.assistantName!=state.assistantName){
                  return null
                }
              }

                 if (state.month != "全部" ){
                let month=item.classDate.split("-")[1]
                console.log(month)
                if (month != state.month) return null;
              }
            return (
            <tr  onClick={() => {
                window.location.href = `/SingleStudentTrialView/${item.studentDBID}`;
              }}
              className="text-muted"
              style={{ textDecoration: "none" }} 
            >
              <td  className="text-center">{index+1}</td>
               <td  className="text-center">{item.studentDBID}</td>
              <td className="text-center">{item.name}-<small className="text-info">{item.nickName}</small></td>
              <td className="text-center">{item.parent} {item.phone}</td>
              <td className="text-center">{item.classDate}
                  
              </td>
              <td className="text-center">{item.classTime}</td>
             
                <td className="text-center">{item.flag=="1" && "是"}</td>
              
              <td className="text-left">
                {follow.map((followItem,index2)=>{
                  if(followItem.studentDBID==item.studentDBID){
                   
                    return (
                      <p>
                        <span> {followItem.nextStep}-{followItem.operatorName}</span>
                      
                      </p>
                    )}
                })
                }
              </td>
              
        
              <td className="text-center">{item.coachName}</td>
              <td className="text-center">{item.assistantName}</td>
            
            </tr>)
})}


            
          </tbody>
        </table>

          </div>
        </div>
      </div>

    </>
  );
};

export default DashBoardMonthlyTrailStudents;
